import {
    DependenciesPayload,
    PaymentHistoryItem,
} from '@sxm-de/dev-kits/web-sdk/types';
import { MapClientSdkToWebSdk } from '@sxm-de/dev-kits/web-sdk/utils';

export async function getBillingProfilePaymentHistory(
    {
        billingProfileId,
        startDateTime,
        endDateTime,
    }: {
        billingProfileId: string;
        startDateTime: string;
        endDateTime: string;
    },
    { clientSdk }: DependenciesPayload,
): Promise<{
    items: PaymentHistoryItem[];
}> {
    const mapClientSdkToWebSdk: MapClientSdkToWebSdk<
        Awaited<
            ReturnType<
                typeof clientSdk.commerce.billing.getBillingProfilePaymentHistory
            >
        >,
        {
            items: PaymentHistoryItem[];
        }
    > = ({ items }) => {
        return {
            items: items.map((item) => {
                if ('payment' in item) {
                    return {
                        payment: {
                            ...item.payment,
                            invoiceId: item.payment.invoiceIds?.[0] || '',
                            paidAt: new Date(item.payment.paidAt),
                            /**
                             * Note:
                             * Looks like ClientSdk model does not contain the wallet property
                             */
                            wallet: (item.payment as any).wallet,
                        },
                    };
                }
                if ('balance' in item) {
                    return {
                        balance: {
                            ...item.balance,
                            invoiceId: item.balance.invoiceId || '',
                            paidAt: new Date(item.balance.paidAt),
                        },
                    };
                }
                if ('refund' in item) {
                    return {
                        refund: {
                            ...item.refund,
                            invoiceId: item.refund.invoiceId || '',
                            paidAt: new Date(item.refund.paidAt),
                            invoiceAdjustmentId:
                                item.refund.invoiceAdjustmentId || '',
                        },
                    };
                }
                return {};
            }),
        };
    };
    const { items } = mapClientSdkToWebSdk(
        await clientSdk.commerce.billing.getBillingProfilePaymentHistory(
            billingProfileId,
            { startDateTime, endDateTime },
        ),
    );
    return { items };
}
